export default {
  PHISH: 'phish',
  SLACK: 'slack',
  MS_TEAMS: 'ms_teams',
};
